import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import parseISO from 'date-fns/parseISO';
import { SET_ADS_DATA } from './types';

const getAdData = (payload = {}) => {
  let { adBreaks } = payload;
  if (!adBreaks) {
    // we are in LiveTV mode: there is only 1 adBreak a time
    const { adBreak, streamStartOffsetFromStartOfEpisode, streamStartTime } = payload;
    if (!adBreak || !adBreak.startTime || !adBreak.ads || !adBreak.adBreakDuration) {
      return {}; // no Ad to set
    }
    const { adBreakDuration, ads, startTime } = adBreak;
    const offsetFromChannelChange = differenceInMilliseconds(
      parseISO(startTime),
      parseISO(streamStartTime),
    );
    const adBreakOffsetFromStartOfEpisode =
      offsetFromChannelChange + streamStartOffsetFromStartOfEpisode;
    adBreaks = [
      {
        adBreakOffsetFromStartOfEpisode, // IN MS
        adBreakDuration, // IN MS
        ads,
        adPodIndex: 0,
        startTime,
      },
    ];
  } else {
    adBreaks = adBreaks.map((brk, idx) => ({
      adBreakOffsetFromStartOfEpisode: brk.startingOffset * 1000, // MS
      adBreakDuration: brk.adBreakDuration, // MS
      ads: brk.ads,
      adPodIndex: idx,
    }));
  }

  return {
    adBreaks,
  };
};

export const playbackSessionSetAdDataAction = actionCreator(SET_ADS_DATA);

// eslint-disable-next-line no-unused-vars
export const podTrackerAdsSetAdDataThunkAction = (payload) => async (dispatch, getState) => {
  const adData = getAdData(payload);
  dispatch(playbackSessionSetAdDataAction(adData));
};
